import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppleLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M12.9177 9.77816C12.8916 7.49566 14.7697 6.41311 14.861 6.3479C14.4858 5.817 13.9925 5.38046 13.4199 5.07265C12.8473 4.76485 12.211 4.59417 11.5612 4.57407C10.1656 4.4306 8.82221 5.39577 8.1179 5.39577C7.41359 5.39577 6.31799 4.58712 5.15718 4.6132C4.39316 4.63368 3.64758 4.85245 2.99362 5.24803C2.33965 5.64361 1.79977 6.20241 1.42694 6.86961C-0.164286 9.62164 1.02261 13.704 2.56166 15.9474C3.31815 17.03 4.23114 18.256 5.405 18.2169C6.55276 18.1777 6.97014 17.4734 8.35267 17.4734C9.73521 17.4734 10.1265 18.2169 11.3264 18.1908C12.5525 18.1777 13.335 17.0821 14.0785 15.9735C14.9523 14.7214 15.3045 13.4954 15.3306 13.4301C15.3045 13.4041 12.9437 12.5171 12.9177 9.77816ZM10.6482 3.08719C11.2743 2.33071 11.6916 1.2612 11.5873 0.217773C10.6743 0.256902 9.5787 0.817743 8.92656 1.57423C8.58903 1.952 8.33082 2.39372 8.16726 2.87319C8.00371 3.35266 7.93813 3.8601 7.97443 4.36539C8.99177 4.44365 10.0222 3.84368 10.6482 3.08719Z",
		fill: "white"
	})
});
export default SvgAppleLogo;
